import { useQuery } from "@tanstack/react-query";

import { useCurrentCompanyId } from "@/hooks/useCurrentCompanyId";
import { useCurrentJobId } from "@/hooks/useCurrentJobId";
import { guacHttpClient } from "@/lib/http";
import { ExternalCandidacyComment, HttpResponse } from "@/types";

export function useGetExternalCandidacyComments({
  candidacyId,
}: {
  candidacyId: string;
}) {
  const currentCompanyId = useCurrentCompanyId();
  const currentJobId = useCurrentJobId();

  return useQuery({
    queryKey: [
      "external-candidacy-comments",
      currentCompanyId,
      currentJobId,
      candidacyId,
    ],
    queryFn: async () => {
      const path = `companies/${currentCompanyId}/jobs/${currentJobId}/candidacies/${candidacyId}/external-candidacy-comments`;
      const res = await guacHttpClient.get<
        ExternalCandidacyComment[],
        HttpResponse<ExternalCandidacyComment[]>
      >(path);
      return res.data;
    },
  });
}
